<template>
  <div>
    <van-uploader
            :deletable="showUpload"
            :show-upload="showUpload"
            v-model="fileList"
            :after-read="afterRead"
            :before-read="beforeRead"
            :max-count="maxCount"
            :max-size="maxSize * 1024" @oversize="onOversize"/>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {customUploadFile} from '@/api/upload'

  export default {
    name: 'custom-upload',
    props: {
      showUpload: {
        type: Boolean,
        default: true
      },
      value: {
        type: String,
        default: ''
      },
      maxCount: {
        type: Number,
        default: () => 5
      },
      maxSize: {
        type: Number,
        default: () => 2048
      }
    },
    data() {
      return {
        filePrefix: FILE_DISPLAY_PREFIX,
        fileList: []
      }
    },
    watch: {
      value(val) {
        this.handleFileList(val)
      }
    },
    created() {
      this.handleFileList(this.value)
    },
    methods: {
      getFileList() {
        return this.fileList.map(i => i.path)
      },
      getUrls() {
        return this.fileList.map(i => i.path).join(",")
      },
      addFileList(path) {
        this.fileList.push({
          url: this.filePrefix + path,
          path: path
        })
      },
      handleFileList(str) {
        const paths = str ? str.split(',') : [];
        paths.forEach(path => {
          this.addFileList(path)
        })
      },
      afterRead(file) {
        customUploadFile(file.file).then(res => {
          if (res.code === 10000) {
            this.addFileList(res.result[0])
          }
        }).catch(e => {
          this.$toast('上传失败' + e)
        }).finally(() => {
          this.fileList = this.fileList.filter(i => i.url)
        })
      },
      beforeRead(file) {
        const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/gif'
        if (!isJpgOrPng) {
          this.$toast('请上传图片格式的文件');
          return false
        }
        return true
      },
      onOversize(file) {
        this.$toast(`文件大小不能超过${this.maxSize}kb`);
      },
    }
  }
</script>

<style lang="less">
</style>
